import React from 'react';
import { useQuery } from '@tanstack/react-query';
import TestType from '../model/TestType';
import { setUrlToHTTPs } from '../utils';
import { matchPath } from 'react-router';
import { useAppendAuthorizationHeader } from '../utils/connector/api-connector';
import TestTypeView from '../components/Views/TestTypeView';
import { Test } from '../components/RequestView/SimpleRequestView';
import Spinner from '../components/Spinner/Spinner';


interface TestTypeControllerI {
    url: string
}
const TestTypeController: React.FC<TestTypeControllerI> = (props) => {

    const {url} = props
    //const {keycloak} = useKeycloak()

    const urlL = new URL(url)

    const testMatchPath = matchPath("/v1/accreditation/testTypes/:type",  urlL.pathname)

    const header = useAppendAuthorizationHeader()

    const testTypeData = useQuery<TestType>({
        queryKey: ['testType', `${testMatchPath?.params.type??0}`],
        queryFn: async () => {
            const data =
                await fetch(setUrlToHTTPs(`${url}`), {...header})
            return data.json()
        }}
    )

    if (testTypeData.isError) {
        return <span>Error</span>
    }

    if (testTypeData.isFetched) {
        const testData = testTypeData.data
        const test: Test = {type: testData?.type??'', version: testData?.version??''}
        return (
            <TestTypeView test={test} row={true}/>
        )
    }
    return <Spinner/>
}
export default TestTypeController